import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  private requestCount = 0;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // 🔹 Check if we should skip loader based on URL pattern
    // Skip for fetchCnraDetails, fetchActivityStream, and fetchUploadedDocuments
    const shouldSkipLoader = /fetchCnraDetails|fetchActivityStream|fetchUploadedDocuments/i.test(req.url);

    if (shouldSkipLoader) {
      return next.handle(req);
    }

    this.showLoader();

    return next.handle(req).pipe(
      finalize(() => this.hideLoader())
    );
  }

  private showLoader() {
    this.requestCount++;
    const loader = document.getElementById('global-loader');
    if (loader) {
      loader.style.display = 'flex';
    }
  }

  private hideLoader() {
    this.requestCount--;
    if (this.requestCount <= 0) {
      const loader = document.getElementById('global-loader');
      if (loader) {
        loader.style.display = 'none';
      }
    }
  }
}
